import { render, staticRenderFns } from "./CsMenu.vue?vue&type=template&id=70d957ad&"
import script from "./CsMenu.vue?vue&type=script&lang=js&"
export * from "./CsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CsMenu.vue?vue&type=style&index=0&id=70d957ad&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports